export default "__VITE_ASSET__g5ODvd9N__"